import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useShopify } from '../../contexts/ShopifyContext';
import './MainLayout.css';

// =====================================================
// Icons (emoji-based like original)
// =====================================================

// Logout icon pointing left
const LogoutLeftIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 3H19a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
    <polyline points="8 17 3 12 8 7" />
    <line x1="3" y1="12" x2="15" y2="12" />
  </svg>
);

// =====================================================
// Navigation Groups (igual ao original)
// =====================================================

const NAV_SECTIONS = [
  {
    title: 'Principal',
    items: [
      { path: '/products', label: 'Produtos', icon: '📦' },
      { path: '/groups', label: 'Grupos', icon: '🗂️' },
      { path: '/catalogs', label: 'Catálogos', icon: '▦' },
      { path: '/personalizations', label: 'Personalizações', icon: '✨' },
      { path: '/discounts', label: 'Descontos', icon: '%' },
    ],
  },
  {
    title: 'Vendas',
    items: [
      { path: '/orders', label: 'Pedidos', icon: '🛒' },
    ],
  },
  {
    title: 'Sistema',
    items: [
      { path: '/monitoring', label: 'Monitoramento', icon: '◉' },
      { path: '/sales-channels', label: 'Canais de Venda', icon: '📡' },
      { path: '/gallery-3d', label: 'Galeria 3D', icon: '▣' },
      { path: '/augmented-reality', label: 'Realidade Aumentada', icon: '📐' },
      { path: '/lab-3d', label: 'Lab 3D', icon: '💎' },
      { path: '/settings', label: 'Configurações', icon: '⚙️' },
    ],
  },
];

// =====================================================
// Main Layout Component
// =====================================================

export const MainLayout: React.FC = () => {
  const { logout } = useAuth();
  const { isEmbedded } = useShopify();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <img src="/assets/images/logo_branco.avif" alt="PACCO" />
        </div>

        <nav className="sidebar-nav">
          {NAV_SECTIONS.map((section) => (
            <div key={section.title} className="nav-section">
              <div className="nav-section-title">{section.title}</div>
              {section.items.map(({ path, label, icon }) => (
                <NavLink
                  key={path}
                  to={path}
                  className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                >
                  <span className="icon">{icon}</span>
                  <span>{label}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          {!isEmbedded && (
            <button className="nav-item logout-btn" onClick={handleLogout}>
              <LogoutLeftIcon />
              <span>Sair</span>
            </button>
          )}
        </div>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};
